import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DistrictAdminDistrictState {
  id: number | null
  name: string | null
  nickname: string | null
  subscriptionType: string | null
  subscriptionStatus: string | null
  subscriptionRenewalDate: string | null
  csmName: string | null
  csmEmail: string | null
  csmPhoneNumber: string | null
  numActiveTeachers: number | null
  numActiveStudents: number | null
  numFocusSessionsByWeek: number[] | null
  weekStartDates: string[] | null
}

export const selectDistrict = (state: any) => state.district

const initialState: DistrictAdminDistrictState = {
  id: null,
  name: null,
  nickname: null,
  subscriptionType: null,
  subscriptionStatus: null,
  subscriptionRenewalDate: null,
  csmName: null,
  csmEmail: null,
  csmPhoneNumber: null,
  numActiveTeachers: null,
  numActiveStudents: null,
  numFocusSessionsByWeek: null,
  weekStartDates: null,
}

const districtSlice = createSlice({
    name: 'district',
    initialState,
    reducers: {
        loadDistrict: (state, { payload: {
                id,
                name,
                nickname,
                subscriptionType,
                subscriptionStatus,
                subscriptionRenewalDate,
                csmName,
                csmEmail,
                csmPhoneNumber,
                numActiveTeachers,
                numActiveStudents,
                numFocusSessionsByWeek,
                weekStartDates,
            }}: PayloadAction<DistrictAdminDistrictState>) => ({
            id,
            name,
            nickname,
            subscriptionType,
            subscriptionStatus,
            subscriptionRenewalDate,
            csmName,
            csmEmail,
            csmPhoneNumber,
            numActiveTeachers,
            numActiveStudents,
            numFocusSessionsByWeek,
            weekStartDates,
        }),
    },
})

export const { loadDistrict } = districtSlice.actions

export default districtSlice.reducer
